import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AnchorLink from '../AnchorLink';
import isEmpty from '../../utils/isEmpty';
import styles from './LinkList.module.scss';

const LinkList = ({ heading, anchorLink, items }) => {
    return (
        <div className={styles['LinkList']}>
            <h2 className={styles['LinkList__Heading']}>
                <AnchorLink
                    classNames={styles['LinkList__Heading']}
                    title={heading}
                    id={anchorLink}
                />
            </h2>
            <div className={styles['LinkList__Links']}>
                {items.map((link, index) => (
                    <Link {...link} key={index} />
                ))}
            </div>
        </div>
    );
};

LinkList.propTypes = {
    heading: PropTypes.string,
    anchorLink: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
            type: PropTypes.string,
        })
    ),
};

LinkList.defaultProps = {
    heading: '',
    anchorLink: '',
    items: [],
};

const Link = ({ href, title, description, type }) => {
    const classes = classNames(
        styles['LinkList__Link'],
        styles[`LinkList__Link--${type}`],
        {
            [styles['LinkList__Link--HasDescription']]: !isEmpty(description),
        }
    );

    return (
        <a className={classes} href={href}>
            <span className={styles['LinkList__Title']}>{title}</span>
            {description && (
                <span className={styles['LinkList__Description']}>
                    {description}
                </span>
            )}
        </a>
    );
};

Link.propTypes = {
    href: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    type: PropTypes.string,
};

Link.defaultProps = {
    href: '',
    title: '',
    description: '',
    type: '',
};

export default LinkList;
